import {
  Table,
  message,
  DatePicker,
  Pagination,
  Image,
  Modal,
  Select,
  Card,
  Input,
  Button,
  Descriptions,
  Tag,
  Statistic,
  Tooltip,
  Empty,
  Spin
} from "antd";

import {
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  SearchOutlined,
  ReloadOutlined,
  ShoppingCartOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  UserOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  EyeOutlined
} from "@ant-design/icons";

import {
  useEffect,
  useState
} from "react";

import {
  useDevice
} from "../../../hooks";

import dayjs from "dayjs";
import axiosInstance from "../../../utils/axios";
import { FormatVND } from "../../../utils/format";
import { orderStatus, payment } from "../../../utils/constants";

const { RangePicker } = DatePicker;


const statusInfo = status => {

  const found =
    orderStatus.find(
      item =>
        Number(item.id) ===
        Number(status)
    );

  return found || {
    id: status,
    data: "Không xác định",
    color: "default"
  };
};


const statusTagColor = status => {

  const color =
    String(
      statusInfo(status)?.color ||
      ""
    ).toLowerCase();

  if (color.includes("green")) {
    return "green";
  }

  if (
    color.includes("yellow") ||
    color.includes("orange")
  ) {
    return "orange";
  }

  if (color.includes("red")) {
    return "red";
  }

  if (color.includes("blue")) {
    return "blue";
  }

  return "default";
};


const getProductImage = productImage => {

  try {

    const images =
      typeof productImage === "string"
        ? JSON.parse(productImage)
        : productImage;

    if (!Array.isArray(images)) {
      return "";
    }

    return (
      images.find(
        item =>
          item?.type === "image"
      )?.data || ""
    );

  } catch (error) {

    return "";
  }
};


export default function OrderManage() {

  const { isMobile } =
    useDevice();

  const now =
    new Date();

  const [order, setOrder] =
    useState([]);

  const [total, setTotal] =
    useState([]);

  const [loading, setLoading] =
    useState(false);

  const [showFilters, setShowFilters] =
    useState(false);

  const [date, setDate] =
    useState({
      fromDate:
        `${now.getFullYear()}-${String(
          now.getMonth() + 1
        ).padStart(2, "0")}-01`,

      toDate:
        `${now.getFullYear()}-${String(
          now.getMonth() + 1
        ).padStart(2, "0")}-${new Date(
          now.getFullYear(),
          now.getMonth() + 1,
          0
        ).getDate()}`
    });

  const [pagination, setPagination] =
    useState({
      page: 1,
      pageSize: 10
    });

  const [filters, setFilters] =
    useState({
      order_id: "",
      fullname: "",
      phone: "",
      email: "",
      status: undefined
    });


  const fetchOrder = async () => {

    setLoading(true);

    const params = {
      ...pagination,
      ...date,
      ...filters
    };

    Object.keys(params).forEach(
      key => {

        if (
          params[key] === undefined ||
          params[key] === ""
        ) {
          delete params[key];
        }
      }
    );

    try {

      const res =
        await axiosInstance.get(
          "/order/getAll",
          {
            params
          }
        );

      const data =
        res?.data || {};

      setOrder(data);
      setTotal(
        data?.totalStatus || []
      );

    } catch (error) {

      console.error(
        "ORDER LOAD ERROR:",
        error
      );

      message.error(
        "Lỗi khi tải danh sách đơn hàng!"
      );

    } finally {

      setLoading(false);
    }
  };


  const updateStatusOrder = async (
    value,
    order_id
  ) => {

    setLoading(true);

    try {

      const res =
        await axiosInstance.post(
          `/order/updateByStatus/${order_id}`,
          {
            status: value
          }
        );

      message.success(
        String(
          res?.data?.message ||
          "Cập nhật trạng thái thành công!"
        )
      );

      await fetchOrder();

    } catch (error) {

      message.error(
        "Không thể cập nhật trạng thái!"
      );

      setLoading(false);
    }
  };


  const removeOrder = async order_id => {

    setLoading(true);

    try {

      const res =
        await axiosInstance.delete(
          `/order/delete/${order_id}`
        );

      message.success(
        res?.data?.message ||
        "Đã xóa đơn hàng!"
      );

      await fetchOrder();

    } catch (error) {

      message.error(
        "Lỗi khi xóa đơn hàng!"
      );

      setLoading(false);
    }
  };


  const confirmDelete = order_id => {

    Modal.confirm({
      title: "Xóa đơn hàng",
      icon:
        <ExclamationCircleOutlined />,
      content:
        `Bạn có chắc chắn muốn xóa đơn hàng #${order_id}?`,
      okText: "Xóa",
      okType: "danger",
      cancelText: "Hủy",
      centered: isMobile,
      onOk() {
        return removeOrder(
          order_id
        );
      }
    });
  };


  const handleFilterChange = (
    key,
    value
  ) => {

    setFilters(
      prev => ({
        ...prev,
        [key]: value
      })
    );

    setPagination(
      prev => ({
        ...prev,
        page: 1
      })
    );
  };


  const resetFilters = () => {

    setFilters({
      order_id: "",
      fullname: "",
      phone: "",
      email: "",
      status: undefined
    });

    setPagination(
      prev => ({
        ...prev,
        page: 1
      })
    );
  };


  const getStatusTotal = id => {

    const found =
      total.find(
        item =>
          Number(
            item?.status ??
            item?.id
          ) === Number(id)
      );

    if (found) {
      return Number(
        found?.total || 0
      );
    }

    const indexed =
      total?.[id];

    return Number(
      indexed?.total || 0
    );
  };


  const orderDetail = value => {

    if (!value) {
      return;
    }

    Modal.info({
      title:
        <span
          className={
            isMobile
              ? "text-base font-bold"
              : "text-xl font-bold"
          }
        >
          Chi tiết đơn hàng #{value.order_id}
        </span>,

      width:
        isMobile
          ? "calc(100% - 20px)"
          : 1000,

      centered:
        isMobile,

      okText:
        "Đóng",

      icon:
        null,

      content: (

        <div
          className="
            pt-3

            max-h-[72vh]

            overflow-y-auto
            overflow-x-hidden
          "
        >

          <Descriptions
            title="Thông tin người nhận"
            bordered
            size={
              isMobile
                ? "small"
                : "middle"
            }
            column={
              isMobile
                ? 1
                : 2
            }
            className="mb-5"
          >

            <Descriptions.Item label="Họ và tên">
              {value?.fullname || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Số điện thoại">
              {value?.phone || "-"}
            </Descriptions.Item>

            <Descriptions.Item label="Email">
              <span className="break-all">
                {value?.email || "-"}
              </span>
            </Descriptions.Item>

            <Descriptions.Item label="Trạng thái">
              <Tag
                color={
                  statusTagColor(
                    value?.status
                  )
                }
              >
                {
                  statusInfo(
                    value?.status
                  )?.data
                }
              </Tag>
            </Descriptions.Item>

            <Descriptions.Item
              label="Địa chỉ nhận"
              span={
                isMobile
                  ? 1
                  : 2
              }
            >
              {value?.to_address || "-"}
            </Descriptions.Item>

            <Descriptions.Item
              label="Tài khoản đặt"
            >
              {
                value?.userFullname ||
                "-"
              }

              {value?.userEmail && (
                <div
                  className="
                    text-xs
                    text-gray-400

                    break-all
                  "
                >
                  {value.userEmail}
                </div>
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Thời gian">
              {
                value?.create_at
                  ? dayjs(
                      value.create_at
                    ).format(
                      "DD/MM/YYYY HH:mm"
                    )
                  : "-"
              }
            </Descriptions.Item>

          </Descriptions>


          <Descriptions
            title="Thanh toán"
            bordered
            size={
              isMobile
                ? "small"
                : "middle"
            }
            column={
              isMobile
                ? 1
                : 2
            }
            className="mb-5"
          >

            <Descriptions.Item label="Hình thức">
              {
                payment.find(
                  method =>
                    Number(
                      method.value
                    ) ===
                    Number(
                      value?.payment
                    )
                )?.label || "-"
              }
            </Descriptions.Item>

            <Descriptions.Item label="Mã voucher">
              {
                value?.voucher_id
                  ? `${value?.voucher_code || ""} (-${FormatVND(
                      value?.voucher_price ||
                      0
                    )})`
                  : "Không có"
              }
            </Descriptions.Item>

            <Descriptions.Item label="Phí giao hàng">
              {
                FormatVND(
                  value?.fee_ship ||
                  0
                )
              }
            </Descriptions.Item>

            <Descriptions.Item label="Tổng thanh toán">
              <span
                className="
                  text-red-500
                  font-bold
                  text-lg
                "
              >
                {
                  FormatVND(
                    value?.total_price ||
                    0
                  )
                }
              </span>
            </Descriptions.Item>

            {value?.payment !== 1 && (
              <>
                <Descriptions.Item label="Nội dung GD">
                  {
                    value?.transfer_content ||
                    "N/A"
                  }
                </Descriptions.Item>

                <Descriptions.Item label="Ảnh minh chứng">
                  {
                    value?.transfer_image
                      ? (
                        <Image
                          width={80}
                          src={
                            value.transfer_image
                          }
                        />
                      )
                      : "Chưa có ảnh"
                  }
                </Descriptions.Item>
              </>
            )}

          </Descriptions>


          <div
            className="
              font-bold
              text-base

              mb-3
            "
          >
            Sản phẩm ({value?.orderDt?.length || 0})
          </div>


          {isMobile ? (

            <div
              className="
                flex
                flex-col
                gap-3
              "
            >

              {(value?.orderDt || []).map(
                (item, index) => {

                  const image =
                    getProductImage(
                      item?.product_image
                    );

                  return (

                    <div
                      key={
                        item?.product_id ||
                        index
                      }

                      className="
                        border
                        border-gray-200

                        rounded-xl

                        p-3

                        flex
                        gap-3
                      "
                    >

                      <div
                        className="
                          w-[70px]
                          h-[70px]

                          rounded-lg

                          bg-gray-100

                          overflow-hidden

                          flex-shrink-0
                        "
                      >
                        {
                          image
                            ? (
                              <Image
                                preview
                                src={image}
                                width="100%"
                                height="100%"
                                style={{
                                  objectFit:
                                    "cover"
                                }}
                              />
                            )
                            : (
                              <div
                                className="
                                  w-full
                                  h-full

                                  flex
                                  items-center
                                  justify-center

                                  text-gray-400
                                "
                              >
                                —
                              </div>
                            )
                        }
                      </div>


                      <div
                        className="
                          flex-1
                          min-w-0
                        "
                      >

                        <div
                          className="
                            font-semibold
                            text-[13px]

                            leading-snug
                          "
                        >
                          {
                            item?.product_name ||
                            "Sản phẩm"
                          }
                        </div>

                        {
                          item?.description && (
                            <div
                              className="
                                text-[11px]
                                text-gray-500

                                mt-1
                              "
                            >
                              {
                                item.description
                              }
                            </div>
                          )
                        }

                        <div
                          className="
                            mt-2

                            flex
                            justify-between
                            items-end

                            gap-2
                          "
                        >

                          <span
                            className="
                              text-xs
                              text-gray-500
                            "
                          >
                            SL:{" "}
                            <b>
                              {
                                item?.quantity ||
                                0
                              }
                            </b>
                          </span>

                          <span
                            className="
                              text-sm
                              font-bold
                              text-red-500
                            "
                          >
                            {
                              FormatVND(
                                item?.price ||
                                0
                              )
                            }
                          </span>

                        </div>

                      </div>

                    </div>

                  );
                }
              )}

            </div>

          ) : (

            <Table
              rowKey={(
                item,
                index
              ) =>
                item?.product_id ||
                index
              }

              dataSource={
                value?.orderDt || []
              }

              pagination={false}
              bordered
              size="small"

              columns={[
                {
                  title: "Sản phẩm",
                  dataIndex:
                    "product_name",
                  key: "name",
                  width: 260
                },
                {
                  title: "Ảnh",
                  key: "image",
                  width: 80,
                  render: (
                    _,
                    record
                  ) => (
                    <Image
                      src={
                        getProductImage(
                          record?.product_image
                        )
                      }
                      width={60}
                    />
                  )
                },
                {
                  title: "Phân loại",
                  dataIndex:
                    "description",
                  key: "desc"
                },
                {
                  title: "SL",
                  dataIndex:
                    "quantity",
                  key: "qty",
                  align: "center"
                },
                {
                  title: "Đơn giá",
                  dataIndex:
                    "price",
                  key: "price",
                  render: value =>
                    FormatVND(value)
                }
              ]}
            />

          )}

        </div>
      )
    });
  };


  useEffect(() => {

    fetchOrder();

  }, [
    pagination.page,
    pagination.pageSize,
    date,
    filters
  ]);


  const columns = [

    {
      title: "ID",
      dataIndex:
        "order_id",
      key:
        "order_id",
      width: 80,
      sorter: (
        a,
        b
      ) =>
        a.order_id -
        b.order_id
    },

    {
      title: "Khách hàng",
      key: "customer",
      width: 190,

      render: (
        _,
        record
      ) => (
        <div>
          <div
            className="
              font-medium
              text-blue-600
            "
          >
            {record?.fullname}
          </div>

          <div
            className="
              text-xs
              text-gray-400
            "
          >
            {record?.phone}
          </div>
        </div>
      )
    },

    {
      title: "Email",
      dataIndex:
        "email",
      key:
        "email",
      width: 220
    },

    {
      title: "Địa chỉ",
      dataIndex:
        "to_address",
      key:
        "to_address",
      width: 260,
      ellipsis: true,

      render: text => (
        <Tooltip
          title={text}
        >
          {text}
        </Tooltip>
      )
    },

    {
      title: "Tổng tiền",
      dataIndex:
        "total_price",
      key:
        "total_price",
      width: 150,
      align: "right",

      render: value => (
        <span
          className="
            font-bold
            text-red-500
          "
        >
          {FormatVND(value)}
        </span>
      ),

      sorter: (
        a,
        b
      ) =>
        a.total_price -
        b.total_price
    },

    {
      title: "Trạng thái",
      dataIndex:
        "status",
      key:
        "status",
      width: 200,

      render: (
        status,
        record
      ) => (

        <Select
          options={
            orderStatus.map(
              item => ({
                value:
                  item.id,

                label:
                  item.data
              })
            )
          }

          className="w-full"

          value={status}

          onChange={value =>
            updateStatusOrder(
              value,
              record?.order_id
            )
          }
        />

      )
    },

    {
      title: "Thời gian",
      dataIndex:
        "create_at",
      key:
        "create_at",
      width: 160,

      render: value =>
        value
          ? dayjs(value)
              .format(
                "DD/MM/YYYY HH:mm"
              )
          : "-"
    },

    {
      title: "",
      key:
        "operation",
      width: 100,

      render: (
        _,
        record
      ) => (

        <div
          className="
            flex
            items-center
            gap-2
          "
        >

          <Button
            type="text"
            icon={
              <InfoCircleOutlined />
            }
            onClick={() =>
              orderDetail(
                record
              )
            }
          />

          <Button
            type="text"
            danger
            icon={
              <DeleteOutlined />
            }
            onClick={() =>
              confirmDelete(
                record?.order_id
              )
            }
          />

        </div>

      )
    }
  ];


  const orders =
    order?.data || [];

  const orderTotal =
    Number(
      order?.total || 0
    );

  const totalPages =
    Math.max(
      1,
      Number(
        order?.totalPage ||
        Math.ceil(
          orderTotal /
          pagination.pageSize
        )
      )
    );


  return (

    <div
      className="
        min-h-screen

        bg-[#f5f7fa]

        p-3
        lg:p-6
      "
    >

      {/* TITLE */}

      <div
        className="
          flex
          flex-col
          lg:flex-row

          lg:items-center
          lg:justify-between

          gap-3

          mb-4
        "
      >

        <div>

          <h1
            className="
              m-0

              text-xl
              lg:text-2xl

              font-bold

              text-gray-900
            "
          >
            Quản lý đơn hàng
          </h1>

          <div
            className="
              mt-1

              text-xs
              lg:text-sm

              text-gray-500
            "
          >
            Xem và xử lý tất cả đơn hàng trên hệ thống
          </div>

        </div>


        <RangePicker
          className="
            w-full
            lg:w-auto
          "

          value={[
            dayjs(
              date.fromDate
            ),
            dayjs(
              date.toDate
            )
          ]}

          onChange={(
            range,
            values
          ) => {

            if (
              range &&
              values?.[0] &&
              values?.[1]
            ) {

              setDate({
                fromDate:
                  values[0],

                toDate:
                  values[1]
              });

              setPagination(
                prev => ({
                  ...prev,
                  page: 1
                })
              );
            }
          }}
        />

      </div>


      {/* STATS */}

      <div
        className="
          grid

          grid-cols-2
          lg:grid-cols-4

          gap-2
          lg:gap-4

          mb-4
        "
      >

        <Card
          size={
            isMobile
              ? "small"
              : "default"
          }
        >
          <Statistic
            title="Đơn mới"
            value={
              getStatusTotal(0)
            }
            prefix={
              <ShoppingCartOutlined />
            }
          />
        </Card>


        <Card
          size={
            isMobile
              ? "small"
              : "default"
          }
        >
          <Statistic
            title="Đang gửi"
            value={
              getStatusTotal(2)
            }
            prefix={
              <ClockCircleOutlined />
            }
          />
        </Card>


        <Card
          size={
            isMobile
              ? "small"
              : "default"
          }
        >
          <Statistic
            title="Thành công"
            value={
              getStatusTotal(1)
            }
            prefix={
              <CheckCircleOutlined />
            }
          />
        </Card>


        <Card
          size={
            isMobile
              ? "small"
              : "default"
          }
        >
          <Statistic
            title="Đã hủy"
            value={
              getStatusTotal(3)
            }
            prefix={
              <CloseCircleOutlined />
            }
          />
        </Card>

      </div>


      {/* MOBILE FILTER BUTTON */}

      {isMobile && (

        <Button
          block

          onClick={() =>
            setShowFilters(
              value => !value
            )
          }

          icon={
            <SearchOutlined />
          }

          className="
            !h-11
            !rounded-xl

            mb-3
          "
        >
          {
            showFilters
              ? "Ẩn bộ lọc"
              : "Tìm kiếm / Lọc đơn"
          }
        </Button>

      )}


      {/* FILTERS */}

      {(!isMobile || showFilters) && (

        <div
          className="
            bg-white

            rounded-2xl

            border
            border-gray-100

            p-3
            lg:p-4

            mb-4
          "
        >

          <div
            className="
              grid

              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-5

              gap-2
              lg:gap-3
            "
          >

            <Input
              placeholder="Mã đơn hàng"

              value={
                filters.order_id
              }

              onChange={event =>
                handleFilterChange(
                  "order_id",
                  event.target.value
                )
              }
            />


            <Input
              placeholder="Tên khách hàng"

              value={
                filters.fullname
              }

              onChange={event =>
                handleFilterChange(
                  "fullname",
                  event.target.value
                )
              }
            />


            <Input
              placeholder="Số điện thoại"

              value={
                filters.phone
              }

              onChange={event =>
                handleFilterChange(
                  "phone",
                  event.target.value
                )
              }
            />


            <Select
              allowClear

              placeholder="Trạng thái"

              className="w-full"

              value={
                filters.status
              }

              options={
                orderStatus.map(
                  item => ({
                    value:
                      item.id,

                    label:
                      item.data
                  })
                )
              }

              onChange={value =>
                handleFilterChange(
                  "status",
                  value
                )
              }
            />


            <div
              className="
                flex
                gap-2
              "
            >

              <Button
                type="primary"

                block

                icon={
                  <SearchOutlined />
                }

                onClick={
                  fetchOrder
                }
              >
                Tìm
              </Button>


              <Button
                icon={
                  <ReloadOutlined />
                }

                onClick={
                  resetFilters
                }
              >
                Reset
              </Button>

            </div>

          </div>

        </div>

      )}


      {/* MOBILE CARDS */}

      {isMobile ? (

        <Spin spinning={loading}>

          {orders.length > 0 ? (

            <div
              className="
                flex
                flex-col
                gap-3
              "
            >

              {orders.map(
                item => (

                  <div
                    key={
                      item?.order_id
                    }

                    className="
                      bg-white

                      rounded-2xl

                      border
                      border-gray-100

                      shadow-sm

                      overflow-hidden
                    "
                  >

                    <div
                      className="
                        p-4
                      "
                    >

                      <div
                        className="
                          flex
                          items-start
                          justify-between

                          gap-3
                        "
                      >

                        <div>

                          <div
                            className="
                              text-xs
                              text-gray-400
                            "
                          >
                            Đơn hàng
                          </div>

                          <div
                            className="
                              mt-0.5

                              text-lg
                              font-bold

                              text-blue-600
                            "
                          >
                            #{item?.order_id}
                          </div>

                        </div>


                        <Tag
                          color={
                            statusTagColor(
                              item?.status
                            )
                          }
                          className="
                            !m-0
                            !rounded-full
                            !px-3
                          "
                        >
                          {
                            statusInfo(
                              item?.status
                            )?.data
                          }
                        </Tag>

                      </div>


                      <div
                        className="
                          mt-4

                          space-y-2.5
                        "
                      >

                        <div
                          className="
                            flex
                            gap-3
                          "
                        >
                          <UserOutlined
                            className="
                              mt-1
                              text-gray-400
                            "
                          />

                          <div>
                            <div
                              className="
                                text-sm
                                font-semibold
                                text-gray-900
                              "
                            >
                              {
                                item?.fullname ||
                                "Khách hàng"
                              }
                            </div>

                            <div
                              className="
                                text-xs
                                text-gray-400
                              "
                            >
                              {item?.email}
                            </div>
                          </div>
                        </div>


                        <div
                          className="
                            flex
                            items-center
                            gap-3

                            text-sm
                            text-gray-700
                          "
                        >
                          <PhoneOutlined
                            className="
                              text-gray-400
                            "
                          />

                          {
                            item?.phone ||
                            "-"
                          }
                        </div>


                        <div
                          className="
                            flex
                            items-start
                            gap-3

                            text-sm
                            text-gray-700
                          "
                        >
                          <EnvironmentOutlined
                            className="
                              mt-1
                              text-gray-400
                            "
                          />

                          <span
                            className="
                              line-clamp-2
                            "
                          >
                            {
                              item?.to_address ||
                              "-"
                            }
                          </span>
                        </div>


                        <div
                          className="
                            flex
                            items-center
                            gap-3

                            text-xs
                            text-gray-500
                          "
                        >
                          <CalendarOutlined />

                          {
                            item?.create_at
                              ? dayjs(
                                  item.create_at
                                ).format(
                                  "DD/MM/YYYY HH:mm"
                                )
                              : "-"
                          }
                        </div>

                      </div>


                      <div
                        className="
                          mt-4

                          pt-3

                          border-t
                          border-gray-100

                          flex
                          items-center
                          justify-between

                          gap-3
                        "
                      >

                        <div>

                          <div
                            className="
                              text-[10px]
                              text-gray-400
                            "
                          >
                            Tổng thanh toán
                          </div>

                          <div
                            className="
                              text-lg
                              font-bold
                              text-red-500
                            "
                          >
                            {
                              FormatVND(
                                item?.total_price ||
                                0
                              )
                            }
                          </div>

                        </div>


                        <Select
                          value={
                            item?.status
                          }

                          options={
                            orderStatus.map(
                              status => ({
                                value:
                                  status.id,

                                label:
                                  status.data
                              })
                            )
                          }

                          onChange={value =>
                            updateStatusOrder(
                              value,
                              item?.order_id
                            )
                          }

                          style={{
                            width: 135
                          }}
                        />

                      </div>

                    </div>


                    <div
                      className="
                        grid
                        grid-cols-[1fr_auto]

                        border-t
                        border-gray-100
                      "
                    >

                      <button
                        type="button"

                        onClick={() =>
                          orderDetail(
                            item
                          )
                        }

                        className="
                          h-12

                          flex
                          items-center
                          justify-center

                          gap-2

                          text-blue-600

                          font-semibold
                          text-sm

                          active:bg-blue-50
                        "
                      >
                        <EyeOutlined />

                        Xem chi tiết
                      </button>


                      <button
                        type="button"

                        onClick={() =>
                          confirmDelete(
                            item?.order_id
                          )
                        }

                        className="
                          w-14
                          h-12

                          border-l
                          border-gray-100

                          flex
                          items-center
                          justify-center

                          text-red-500

                          active:bg-red-50
                        "
                      >
                        <DeleteOutlined />
                      </button>

                    </div>

                  </div>

                )
              )}

            </div>

          ) : (

            <div
              className="
                bg-white

                rounded-2xl

                py-14
              "
            >
              <Empty
                description="Không có đơn hàng"
              />
            </div>

          )}


          {orderTotal > 0 && (

            <div
              className="
                mt-4
                mb-8

                bg-white

                rounded-2xl

                border
                border-gray-100

                p-3

                flex
                items-center
                justify-between
              "
            >

              <Button
                disabled={
                  pagination.page <= 1
                }

                onClick={() =>
                  setPagination(
                    prev => ({
                      ...prev,
                      page:
                        prev.page - 1
                    })
                  )
                }
              >
                Trước
              </Button>


              <div
                className="
                  text-sm
                  text-gray-500
                "
              >
                <b
                  className="
                    text-gray-900
                  "
                >
                  {pagination.page}
                </b>

                {" / "}

                {totalPages}
              </div>


              <Button
                type="primary"

                disabled={
                  pagination.page >=
                  totalPages
                }

                onClick={() =>
                  setPagination(
                    prev => ({
                      ...prev,
                      page:
                        prev.page + 1
                    })
                  )
                }
              >
                Sau
              </Button>

            </div>

          )}

        </Spin>

      ) : (

        /* DESKTOP */

        <div
          className="
            bg-white

            rounded-2xl

            border
            border-gray-100

            overflow-hidden
          "
        >

          <Table
            rowKey="order_id"

            loading={loading}

            dataSource={
              orders
            }

            columns={
              columns
            }

            pagination={
              false
            }

            scroll={{
              x: 1300
            }}
          />


          <div
            className="
              py-5

              flex
              justify-center
            "
          >

            <Pagination
              current={
                pagination.page
              }

              total={
                orderTotal
              }

              pageSize={
                pagination.pageSize
              }

              showSizeChanger

              onChange={(
                page,
                pageSize
              ) =>
                setPagination({
                  page,
                  pageSize
                })
              }
            />

          </div>

        </div>

      )}

    </div>
  );
}
